export enum VrmRatingScore {
  lowRisk = 1,
  mediumRisk = 2,
  highRisk = 3,
  veryHighRisk = 4,
}

export enum VrmRatingClasses {
  lowRisk = 'agGridGreenTexts',
  mediumRisk = 'agGridAmberTexts',
  highRisk = 'agGridRedTexts',
  veryHighRisk = 'agGridRedTexts',
}

export enum VrmRating {
  veryHighRisk = 'very_high',
  highRisk = 'highRisk',
  mediumRisk = 'mediumRisk',
  lowRisk = 'lowRisk',
}
